:host {
  color:red;
  align-self:flex-end;
  
  flex-basis: 100%;
  >div {
      //width:100%;
      //margin-top:.5rem;
      //margin-left: -1rem;
      //margin-right:-1rem;
      background-color: var(--blue);
      color: var(--white);
      padding-top:.5rem;
      padding-left:1rem;
      padding-right:1rem;
      padding-bottom:.5rem;
      
  }

  

  .epic-waittime {
      display:flex;
      flex-direction: row;
      
      >div:first-child {
          padding-right:1rem;
          flex-basis:20%;
          text-align: center;
          display: flex;
          flex-direction: column;
          justify-content: space-evenly;
          font-weight:bolder;
          //font-size: larger;
          text-transform: uppercase;
          >div {
              span {
                  font-size:135%;
              }
          }
      }
      >div:last-child {
          flex-grow: 1;
          .title {
              font-weight:900;
          }
          .current-wait {
              font-size: .85rem;
          }
          .link {
              display:flex;
              align-self: flex-end;
              margin-top: auto;
              flex: 0 0 100%;
              width: 100%;
              border-left: none;
              padding: 0 !important;
              margin-left: 0 !important;
              //margin-top: 1rem;
              justify-content: flex-end;
              color: var(--white);
              text-decoration: none;
              a {
                  display: inline-flex;
                  align-items: center;
                  color: var(--white);
                  text-decoration: none;
                  font-size: .85rem;
                  span {
                      margin-right: 8px;
                  }
                  &:hover {
                      text-decoration: underline;
                  }
  
                  
              }
          }
      }
      
  }
}

